import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AbstractControl, FormArray, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { IBillingDocument, IBillingDocumentDetail, IBillingDocumentFilter, IBillingDocumentTypeNames, IBillingDocumentTypes, PaymentMethodTypes } from '../billing-documents.interface';
import { BillingDocumentService } from '../billing-documents.service';
import { Observable, Subscription, debounceTime, distinctUntilChanged, lastValueFrom, of, startWith, switchMap } from 'rxjs';

import { InvoiceStatuses, InvoiceStatusesColors, InvoiceStatusesLabels } from '../billing-documents.constants';
import { BillingDocumentsPDFModalComponent } from '../billing-documents-pdf-modal/billing-documents-pdf-modal.component';
import notify from 'devextreme/ui/notify';
import { ActivatedRoute, Router } from '@angular/router';
import { ICounter, ICounterFilter } from '../../../counters-page/counters/counters.interface';
import { MyErrorStateMatcher } from '../../../../shared/util/error-state-matcher';
import { ICompany } from '../../../companies-page/companies/companies.interface';
import { IServiceAgreement } from '../../../service-agreements-page/service-agreements/service-agreements.interface';
import { ITask } from '../../../tasks-page/tasks/task.interface';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { CompaniesService } from '../../../companies-page/companies/companies.service';
import { ClientsService } from '../../../clients-page/clients/clients.service';
import { SettingsService } from '../../../settings-page/settings/settings.service';
import { AlertService } from '../../../../shared/services/alert.service';
import { TaskHttpService } from '../../../tasks-page/tasks/task-http.service';
import { CountersService } from '../../../counters-page/counters/counters.service';
import { Broadcaster } from '../../../../shared/components/broadcaster.component';
import { SETTINGS } from '../../../settings-page/settings/settings.constants';
import { getEmptyDetailItem } from '../../../../shared/components/detail-item/detail-item.interface';
import { CountersModalComponent } from '../../../counters-page/counters/counter-modal/counters-modal.component';
import { IClient } from '../../../clients-page/clients/clients.interface';
import { TaskSearchComponent } from '../../../tasks-page/tasks/task-search/task-search.component';
import { TaxPercentage } from '../../../../shared/constants/global.constants';
import { roundNum } from '../../../../shared/services/utils.service';
import { CompaniesModalComponent } from '../../../companies-page/companies/companies-modal/companies-modal.component';
import { ClientsModalComponent } from '../../../clients-page/clients/clients-modal/clients-modal.component';
import { IConfirmationDialogOptions } from '../../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { IInformationDialogOptions } from '../../../../shared/services/dialog/information-dialog/information-dialog-options.interface';

declare const $: any;
let self: any;

@Component({
  selector: 'app-billing-documents-modal',
  templateUrl: './billing-documents-modal.component.html',
  styleUrls: ['./billing-documents-modal.component.css']
})
export class BillingDocumentsModalComponent implements OnInit {
  @ViewChild('billingDocModal') dialogElement!: ElementRef;
  document: IBillingDocument = {};
  loading: boolean = false;
  readOnly: boolean = false;
  editting: boolean = false;
  dialog: MatDialogRef<any>;
  isDev!: boolean;
  curr!: string;
  billingDocumentTypes: any = IBillingDocumentTypes;
  billingDocumentTypeNames: any = IBillingDocumentTypeNames;
  accordionOpenIndexes: number[] = [];
  hasTermAndCond: boolean = false;
  defaultTermAndCond: string = '';
  paymentMethodTypes: any; //  = _.cloneDeep(PaymentMethodTypes);
  paymentMethodTypesKeys: any; // = Object.keys(this.paymentMethodTypes);
  paymentNumberTransfer: string = "";
  form!: UntypedFormGroup;
  saving: boolean = false;
  submitted = false;
  action: string = '';
  filterCounter!: ICounterFilter;
  counters: ICounter[] = [];
  customErrorStateMatcher = new MyErrorStateMatcher();

  subscriptions: Subscription;
  formValueChanged: boolean = false;
  constructedForm: boolean = false;
  refreshPage: boolean = false;

  //comapny
  companyId!: string;
  currentCompany!: ICompany;
  allDataToBilling: boolean = true;

  // clients
  $clients: Observable<any> = of();
  clientsTerm: string = '';

  // agreement invoicing
  agreements: IServiceAgreement[] = [];
  agreementsTaskDates: any = {};

  // bulk task invoicing
  tasks: ITask[] = [];
  series: string[] = ['FAC'];
  newSerie: boolean = false;

  invoiceStatuses = InvoiceStatuses;
  invoiceStatusesColors = InvoiceStatusesColors;
  invoiceStatusesLabels = InvoiceStatusesLabels;
  invoiceStatusesKeys = Object.keys(InvoiceStatuses);
  redirectToBill = false;
  project!: string;

  constructor(
    private _BillingDocumentService: BillingDocumentService,
    public dialogRef: MatDialogRef<any>,
    private _viewContainerRef: ViewContainerRef,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _AuthService: AuthService,
    private _CompaniesService: CompaniesService,
    public _ClientsService: ClientsService,
    public _SettingsService: SettingsService,
    private fb: UntypedFormBuilder,
    private _AlertService: AlertService,
    private _TaskHttpService: TaskHttpService,
    private _CountersService: CountersService,
    private _router: Router,
    private _broadcaster: Broadcaster,
  ) {
    self = this;
    this.dialog = dialogRef;
    this.subscriptions = new Subscription();
  }

  async ngOnInit() {
    this.filterCounter = {
      company: this._AuthService.companyId(),
      filters: {
        id: 'billing_counter',
      },
      sort: '',
      skip: 0,
      limit: 10000
    };
    this.isDev = this._AuthService.isRole('dev');
    this.curr = this._AuthService.currency();
    console.log(this.project)

    this._SettingsService.getCompanySettingValue(SETTINGS.PAYMENT_OPTIONS)
      .then((el: string) => {
        this.paymentMethodTypes = JSON.parse(el);
        this.paymentMethodTypesKeys = Object.keys(this.paymentMethodTypes);
      });

    //this.form.get('paymentMethodType').setValue('WIRE_TRANSFER');
    // if (this.paymentMethodTypesKeys.includes('TRANSFER')) {
    //   this.form.get('paymentMethodType').setValue('TRANSFER');
    // }

    this._SettingsService.getCompanySettingValue(SETTINGS.PAYMENT_OPTIONS_WIRE_TRANSFER_ACCOUNT_NUMBER)
      .then((el: string) => {
        this.paymentNumberTransfer = el;
      });

    this.companyId = this._AuthService.companyId();
    this.getCompany();

    this.getCounters().subscribe(() => { });

    await this._SettingsService.getCompanySettingValue(SETTINGS.INVOICE_TERMS_AND_CONDITIONS)
      .then((tc: string) => { this.defaultTermAndCond = tc });

    if (!(self.document?.details?.length > 0)) this.document.details = [getEmptyDetailItem()];
    /*
    this.document.details.forEach(detail => {
      if (detail.serviceAgreement ) detail.details = detail.details.length > 0 ? detail.details : [getEmptyDetailItem()]
      if (detail.task) detail.details = detail.details.length > 0 ? detail.details : [getEmptyDetailItem()]
    });
    */

    if (this.document._id) {
      this.editting = true;
      this.action = 'Modificar';
      await this.getDocument();
      this.getReceipt();
    }
    else {
      if (this.agreements.length > 0) {
        // console.log(this.agreements);

        self.document.details = this.agreements.map(agreement => {

          if (!agreement.details || agreement.details.length == 0) agreement.details = [getEmptyDetailItem()];
          let details = agreement.details.map(detail => {
            return {
              product: detail.product,
              detail: detail.detail ?? detail.name ?? detail.product?.name ?? '',
              description: detail.description ?? detail.product?.description ?? '',
              price: detail.price ?? detail.product?.price ?? 0,
              cost: detail.cost ?? detail.product?.cost ?? 0,
              quantity: detail.quantity ?? 1,
              unit: detail.unit ?? 'unidad',
              subtotal: detail.subtotal ?? 0,
              taxPercentage: detail.taxPercentage ?? 0,
              tax: detail.tax ?? 0,
              total: detail.total ?? 0,
            }
          })
          /*
          details = details.concat((agreement as any).tasks.map(task => {
            return {
              task: task,
              detail: 'Trabajo: ' + new Date(task.scheduledStart).toISOString().substring(0, 10),
              description: task.description ?? 'Trabajo: ' + (task.title || '') + ' (' + (_.get(task, 'category[0].name') || '') + ')',
              price: task.subtotal,
              quantity: 1,
              subtotal: task.subtotal ?? 0,
              taxPercentage: undefined, // cuando hay task no mostrar !!!
              tax: task.tax ?? 0,
              total: task.total ?? 0,
              details: task.products.map(detail => {
                return {
                  product: detail.product,
                  detail: detail.detail ?? detail.name ?? detail.product?.name ?? '',
                  description: detail.description ?? detail.product?.description ?? '',
                  price: detail.price ?? detail.product?.price ?? 0,
                  quantity: detail.quantity ?? 1,
                  subtotal: detail.subtotal ?? 0,
                  taxPercentage: detail.taxPercentage ?? 0,
                  tax: detail.tax ?? 0,
                  total: detail.total ?? 0,
                }
              })
            }
          })) */

          const formattedStartDate = this.formatDate(this.agreementsTaskDates.start);
          const formattedEndDate = this.formatDate(this.agreementsTaskDates.end);

          return {
            serviceAgreement: agreement,
            detail: agreement.category?.name,
            description: agreement.description ?? 'Período: ' + formattedStartDate +
              ' al ' + formattedEndDate +
              ' (' + ((agreement as any).tasks?.length ?? 0) + ' trabajos)',
            price: agreement.subtotal,
            cost: agreement.cost,
            quantity: 1,
            taxPercentage: undefined, // cuando hay task no mostrar !!!
            tax: agreement.tax ?? 0,
            total: agreement.total ?? 0,

            details: details
          };
        });

        this.document.client = await this._ClientsService.getClient(self.document.client).toPromise();
        // console.log(this.agreements, this.document.details);
      }
      else if (this.tasks.length > 0) {

        this.document.details = this.tasks.map((task: any) => {
          if (!task.products || task.products.length == 0) task.products = [getEmptyDetailItem()];
          return {
            task: task,
            detail: 'Trabajo: ' + new Date(task.scheduledStart).toISOString().substring(0, 10) + (task.title ? ' - ' + task.title : ''),
            description: task.description ?? 'Trabajo: ' + (task.title || '') + ' (' + (_.get(task, 'category[0].name') || '') + ')',
            price: task.subtotal,
            cost: task.cost ?? 0,
            quantity: 1,
            subtotal: task.subtotal ?? 0,
            taxPercentage: undefined, // cuando hay task no mostrar !!!
            tax: task.tax ?? 0,
            total: task.total ?? 0,
            details: task.products.map((detail: any) => {
              return {
                product: detail.product,
                detail: detail.detail ?? detail.name ?? detail.product?.name ?? '',
                description: detail.description ?? detail.product?.description ?? '',
                price: detail.price ?? detail.product?.price ?? 0,
                cost: detail.cost ?? detail.product?.cost ?? 0,
                quantity: detail.quantity ?? 1,
                unit: detail.unit ?? 'unidad',
                subtotal: detail.subtotal ?? 0,
                taxPercentage: detail.taxPercentage ?? 0,
                tax: detail.tax ?? 0,
                total: detail.total ?? 0,
              }
            })
          }
        });
        this.document.client = await this._ClientsService.getClient(self.document.client).toPromise();
        console.log(this.tasks, this.document.details);
      }

      if (this.tasks.length <= 1) {
        this.document.notes = this.tasks[0]?.deliverynote?.description ? this.tasks[0]?.deliverynote?.description : '';
      }
      this.document.termsAndConditions = this.defaultTermAndCond || ' ';
      this.action = 'Crear';
      await this.buildForm();

      // REFACTOR: Has to wait for the form to be built for the first time
      setTimeout(() => {
        this.constructedForm = true;
      }, 4000);
      // REFACTOR

      // console.log(this.f.paymentMethodType.value)
      // console.log(this.f.paymentMethod.value)
      this.onPaymentMethodTypeChange(this.f['paymentMethodType'].value)
    }

    // disable click outside modal
    self.dialogRef.disableClose = true;
    self.dialogRef.backdropClick().subscribe(() => {
      this.closeModal()
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getCounters(): Observable<void> {
    return new Observable<void>((observer) => {
      this.counters = [];
      this._CountersService.getCountersSeries(this.filterCounter).subscribe((counters) => {
        const filteredCounters = counters.filter((counter: any) => counter.reference_value.serie !== "DRAFT");
        this.counters = _.concat(this.counters, filteredCounters);
        // console.log(this.counters);
        observer.next();
        observer.complete();
      });
    });
  }

  async getDocument() {
    try {
      const document = await lastValueFrom(this._BillingDocumentService.getBillingDocument(this.document));

      console.log(document);
      document.status = (document.status || '').replace('PENDING', '');
      this.document = document;
      self.document.details = self.document.details.map((detail: any) => {
        console.log('typeof detail.task', typeof detail.task, detail);
        if (detail.details?.length > 0) return detail;
        if (!detail.task) {
          const item = {
            detail: detail.detail ?? '',
            description: detail.description ?? '',
            price: detail.price ?? detail.subtotal ?? 0,
            cost: detail.cost ?? 0,
            quantity: detail.quantity ?? 1,
            subtotal: detail.subtotal ?? 0,
            taxPercentage: detail.taxPercentage ?? 0,
            tax: detail.tax ?? 0,
            total: detail.total ?? 0,
            details: []
          };
          //console.log('poronga', poronga);
          return item;
        }
        if (detail.task?.products?.length == 0) return [getEmptyDetailItem()];
        if (detail.task?.products?.length > 0) {
          const item = {
            task: detail.task,
            detail: 'Trabajo: ' + new Date(detail.task.scheduledStart).toISOString().substring(0, 10) + (detail.task.title ? ' - ' + detail.task.title : ''),
            description: detail.task.description ?? 'Trabajo: ' + (detail.task.title || '') + ' (' + (_.get(detail.task, 'category[0].name') || '') + ')',
            price: detail.task.subtotal,
            cost: detail.task.cost,
            quantity: 1,
            subtotal: detail.task.subtotal ?? 0,
            taxPercentage: undefined, // cuando hay task no mostrar !!!
            tax: detail.task.tax ?? 0,
            total: detail.task.total ?? 0,
            details: detail.task.products.map((detail: any) => {
              return {
                product: detail.product,
                detail: detail.detail ?? detail.name ?? detail.product?.name ?? '',
                description: detail.description ?? detail.product?.description ?? '',
                price: detail.price ?? detail.product?.price ?? 0,
                cost: detail.cost ?? detail.product?.cost ?? 0,
                quantity: detail.quantity ?? 1,
                unit: detail.unit ?? 'unidad',
                subtotal: detail.subtotal ?? 0,
                taxPercentage: detail.taxPercentage ?? 0,
                tax: detail.tax ?? 0,
                total: detail.total ?? 0,
              };
            })
          };
          return item;
        }

        return getEmptyDetailItem();
      });

      await this.buildForm();

      // REFACTOR: Has to wait for the form to be built for the first time
      setTimeout(() => {
        this.constructedForm = true;
      }, 4000);
      // REFACTOR

    } catch (error) {
      console.error('Error fetching document:', error);
    }
  }

  getCompany(reset?: boolean) {
    if (reset) {
      window.scroll(0, 0);
      this.currentCompany = {};
    }
    this._CompaniesService.getCompany(this.companyId).subscribe((company) => {
      this.currentCompany = company;
      if (!this.currentCompany.name || !this.currentCompany.email || !this.currentCompany.phone || !this.currentCompany.taxId) {
        this.allDataToBilling = false;
      } else {
        this.allDataToBilling = true;
      }
    });
  }

  async getReceipt() {
    const receipt = await this._BillingDocumentService.getReceipt(this.document).toPromise();
    this.document.receipt = receipt ? receipt._id : undefined;
  }

  getInvoiceStatusColor(status: string): string {
    return this.invoiceStatusesColors[status as keyof typeof this.invoiceStatusesColors] || this.invoiceStatusesColors.ISSUED;
  }

  getInvoiceStatusLabel(status: string): string {
    return this.invoiceStatusesLabels[status as keyof typeof this.invoiceStatusesLabels] || '';
  }

  get f() { return this.form.controls; }
  async buildForm() {
    const currentDate = new Date();
    const nextMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, currentDate.getDate());

    const dueDate = (this.document.dueDate ? new Date(this.document.dueDate).toISOString().substring(0, 10) : nextMonthDate.toISOString().substring(0, 10));

    /*
    console.log()
    const details = (this.document.details || [{ taxPercentage: TaxPercentage, subtotal: 0, tax: 0, total: 0 } as IBillingDocumentDetail])
      .map(detail => {
        const taskDetail = detail.task ? (_.get(detail, 'task.title') || '') + ' (' + (_.get(detail, 'task.category[0].name') || '') + ')' : '';
        const TaxRounded = detail.task ? roundNum(_.get(detail, 'task.tax'), 2) : roundNum(detail.tax, 2);
        const TotalRounded = detail.task ? roundNum(_.get(detail, 'task.total'), 2) : roundNum(detail.total, 2);

        return {
          task: detail.task,
          detail: detail.detail || taskDetail,
          subtotal: detail.subtotal || _.get(detail, 'task.subtotal', 0),
          taxPercentage: detail.taxPercentage || _.get(detail, 'task.taxPercentage', 0),
          tax: TaxRounded || _.get(detail, 'task.tax', 0),
          total: TotalRounded || _.get(detail, 'task.total', 0)
        }
      })
      .map(detail => this.fb.group(detail));
    */

    this.hasTermAndCond = (this.document.termsAndConditions || '').length > 0;

    const status = this.document.status ? this.document.status : this.invoiceStatuses.ISSUED;
                    
    this.form = this.fb.group({
      client: [this.document.client, Validators.compose([Validators.required, clientValidator])],
      date: [new Date(this.document.date ? this.document.date : new Date()).toISOString().substring(0, 10)],
      dueDate: [dueDate],
      type: this.billingDocumentTypes.INVOICE,
      // details: this.fb.array(details),
      subtotal: [this.document.subtotal || 0],
      tax: [this.document.tax || 0],
      total: [this.document.total || 0],
      paymentMethod: [this.document.paymentMethod || ''],
      paymentMethodType: [this.document.paymentMethodType || 'WIRE_TRANSFER'],
      serie: [this.document.serie ?? '', [Validators.required]],
      docNumber: [this.document.docNumber || this.document.number || 0],
      notes: [this.document.notes || ''],
      termsAndConditions: [this.document.termsAndConditions || ''],
      status: [status]
    } /*, {
      validators: [
        oneOrMoreDetails()
      ]
    } */ );

    // this.calculateTotals();

    this.$clients = this.f['client'].valueChanges
      .pipe(
        startWith(''),
        debounceTime(100),
        distinctUntilChanged(),
        switchMap(val => {
          this.clientsTerm = val;
          return this.filterClients(val || '')
        })
      );

    // if (details.length == 1) this.toggleAccordion(0);
    //console.log(this.f.paymentMethodType)
    //this.onPaymentMethodTypeChange( this.f.paymentMethodType.value)

    if (this.document._id) this.f['client'].markAllAsTouched();
    this.subscriptions.add(this.form.valueChanges.subscribe(async event => await this.onFormValueChange(event)));
  }

  async onFormValueChange(event: any) {
    //console.log(this.constructedForm)
    if (this.constructedForm) {
      this.formValueChanged = true;
    }
  }

  notEditableAlert: boolean = false;
  setEditable(value: boolean = true) {
    //console.log(this.document.status);
    if (value && ((this.document.status == this.invoiceStatuses.CANCELLED) || (this.document.status == this.invoiceStatuses.PAID))) {
      if (!this.notEditableAlert) {
        this.notEditableAlert = true;
        return this._AlertService.warn("No es posible editar facturas " + (
          (this.document.status == this.invoiceStatuses.CANCELLED) ? 'Canceladas' :
            (this.document.status == this.invoiceStatuses.PAID) ? 'Pagadas' : ''));
      }
      else return;
    }
    this.readOnly = !value;
  }

  setTermAndCond() {
    this.hasTermAndCond = !this.hasTermAndCond;
    if (this.hasTermAndCond && !(this.document.termsAndConditions || this.f['termsAndConditions'].value)) {
      this.f['termsAndConditions'].setValue(this.defaultTermAndCond);
    }
    if (!this.hasTermAndCond) {
      this.f['termsAndConditions'].setValue("");
    }
  }

  cancelSubmit() {
    if (!this.document._id) return this.dialog.close();
    Object.keys(this.form.controls).forEach((key) => this.form.controls[key].setErrors(null));
    this.setEditable(false);
    this.getDocument();
  }

  onPaymentMethodTypeChange(selectedMethod?: string) {
    this.form.get('paymentMethod')?.setValue(selectedMethod === 'WIRE_TRANSFER' ? this.paymentNumberTransfer : '')
  }

  filterClients(val: string): Observable<any[]> {

    if (typeof val === 'string') {
      return this._ClientsService.getClients({
        sort: 'firstname lastname',
        skip: 0,
        limit: 5000,
        filters: { client: val, isDeleted: false },
        company: this._AuthService.companyId()
      });
    } else {
      return new Observable<any[]>;
    }
  }

  openNewCountersModal() {
    this.openCountersModal({});
  }

  openCountersModal(counter: ICounter, readOnly: boolean = false) {
    let config = new MatDialogConfig();
    config.width = '350px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.counterDialogRef = this._dialog.open(CountersModalComponent, config);
    self.counterDialogRef.componentInstance.readOnly = true;

    self.counterDialogRef.afterClosed().subscribe((result: any) => {
      this.getCounters().subscribe(() => {
        this.f['serie'].setValue(self.counters[this.counters.length - 1].reference_value.serie);
      });
      self.counterDialogRef = null;
    });
  }

  displayClientsFn(client: IClient): string {
    if (client) {
      const firstName = client.firstname?.trim();
      const lastName = client.lastname ? " " + client.lastname.trim() : '';
      return firstName + lastName;
    } else {
      return '';
    }
  }

  clearClient() {
    this.f['client'].setValue(null);
  }

  dueDateChange() {
    console.log(this.f['dueDate'].value);
  }

  /*
  calculateTotals() {
    const details = this.f.details.value;
    let subtotal = 0, tax = 0, total = 0;
    details.forEach((detail: IBillingDocumentDetail) => {
      subtotal += detail.subtotal;
      tax += roundNum(detail.tax);
      total += roundNum(detail.total);
    });
    this.f.subtotal.setValue(subtotal);
    this.f.tax.setValue(tax);
    this.f.total.setValue(total);
  }
  */

  formatDate(date: any) {
    return new Date(date).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };


  openTaskSearchModal() {
    const client = this.f['client'].value;
    if (!client) return this._AlertService.warn('Seleccione cliente para habilitar la búsqueda de sus trabajos completados');

    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '1100px';
    config.maxWidth = '90vw';
    config.panelClass = 'calendar-task';
    config.viewContainerRef = this._viewContainerRef;
    self.taskSearchDialogRef = this._dialog.open(TaskSearchComponent, config);
    self.taskSearchDialogRef.componentInstance.status = 'COMPLETED';
    self.taskSearchDialogRef.componentInstance.clientId = client._id;
    if (this.project) self.taskSearchDialogRef.componentInstance.project = this.project;
    if ((this.tasks[0] as any)?.project) self.taskSearchDialogRef.componentInstance.project = (this.tasks[0] as any)?.project;

    self.taskSearchDialogRef.afterClosed().subscribe((result: any) => {
      //console.log(result);
      if (result) this.addTaskItem(result);
      self.taskSearchDialogRef = null;
    });
  }

  addTaskItem(task: ITask) {
    console.log(task)
    try { task.status = (task.status || '').replace('PENDING', ''); } catch (e) { }
    let details: any = this.document.details;
    const found = details.filter((d: any) => _.get(d, 'task._id', '') == task._id);
    if (found.length) return this._AlertService.warn('Trabajo ya incluido en esta factura');
    const lastDetail = details[details.length - 1];
    if (lastDetail.detail == '' && lastDetail.total == 0) details.pop();
    if (!task.products || task.products.length == 0) task.products = [getEmptyDetailItem()];

    // formatDate(date) {
    //     const d = new Date(date);
    //     const day = ('0' + d.getDate()).slice(-2);
    //     const month = ('0' + (d.getMonth() + 1)).slice(-2);
    //     const year = d.getFullYear();
    //     return `${day}-${month}-${year}`;
    // };

    const formattedDate = this.formatDate(task.scheduledStart);

    const newDetail = {
      task: task,
      detail: 'Trabajo: ' + formattedDate + (task.title ? ' - ' + task.title : ''),
      description: task.description ?? 'Trabajo: ' + (task.title || '') + ' (' + (_.get(task, 'category[0].name') || '') + ')',
      price: task.subtotal,
      cost: task.cost,
      quantity: 1,
      subtotal: task.subtotal ?? 0,
      taxPercentage: undefined, // cuando hay task no mostrar !!!
      tax: task.tax ?? 0,
      total: task.total ?? 0,
      details: task.products.map(detail => {
        return {
          product: detail.product,
          detail: detail.detail ?? detail.name ?? detail.product?.name ?? '',
          description: detail.description ?? detail.product?.description ?? '',
          price: detail.price ?? detail.product?.price ?? 0,
          cost: detail.cost ?? detail.product?.cost ?? 0,
          quantity: detail.quantity ?? 1,
          unit: detail.unit ?? 'unidad',
          subtotal: detail.subtotal ?? 0,
          taxPercentage: detail.taxPercentage ?? 0,
          tax: detail.tax ?? 0,
          total: detail.total ?? 0,
        }
      })
    }
    details.push(newDetail);

    /*
    const taskDetail = (task.title || '') + ' (' + (_.get(task, 'category[0].name') || '') + ')';
    details.push(this.fb.group({ task: task, detail: taskDetail, subtotal: task.subtotal, taxPercentage: task.taxPercentage, tax: task.tax, total: task.total }));
    // details.push(this.fb.group({ detail: '', subtotal: 0, taxPercentage: TaxPercentage, tax: 0, total: 0 }));
    // this.calculateTotals();
    details = this.f.details as FormArray;
    this.openAccordionItem(details.controls.length - 1);
    */
  }

  addItem() {
    const details = this.f['details'] as FormArray;
    if (details.controls.every(control => (
      control.value.detail !== '' &&
      control.value.total !== 0
    ))) {
      details.push(this.fb.group({ detail: '', subtotal: 0, taxPercentage: TaxPercentage, tax: 0, total: 0 }));
      // this.calculateTotals();
      // this.toggleAccordion(details.length - 1);
    } else {
      this._AlertService.warn("Para añadir una nueva línea, por favor complete la anterior");
    }
  }

  removeItem(i: number) {
    const details = this.f['details'] as FormArray;
    // this.toggleAccordion(i);
    details.removeAt(i);
    if (details.length == 0) {
      setTimeout(() => {
        details.push(this.fb.group({ detail: '', subtotal: 0, taxPercentage: TaxPercentage, tax: 0, total: 0 }));
        // this.toggleAccordion(0);
      }, 250);
    }
    // this.calculateTotals();
  }

  updateItem(i: number) {
    const details = this.f['details'] as FormArray;
    if (details.at(i) instanceof FormGroup) {
      const currentRow = details.at(i) as FormGroup;

      let taxPercentage = currentRow.get('taxPercentage')?.value;
      let subtotal = currentRow.get('subtotal')?.value;

      const newTax = (taxPercentage * subtotal / 100);
      const newTotal = (subtotal + newTax);

      currentRow.get('tax')?.setValue(String(roundNum(newTax, 2)) || 0);
      currentRow.get('total')?.setValue(String(roundNum(newTotal, 2)) || 0);
    }
    // this.calculateTotals();
  }

  openAccordionItem(index: number) {
    this.accordionOpenIndexes = [index];
  }

  /*
  toggleAccordion(index: number): void {
    const isOpen = this.accordionOpenIndexes.includes(index);
    if (isOpen) this.accordionOpenIndexes = [];
    else this.accordionOpenIndexes = [index];
  }
  */

  scrollDialogToTop() {
    if (this.dialogElement && this.dialogElement.nativeElement) {
      this.dialogElement.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  taskProductsChange(data: any, item: any) {
    item.controls.task.value.toUpdate = true;
    item.controls.task.value.subtotal = data.subtotal;
    item.controls.task.value.tax = data.tax;
    item.controls.task.value.taxPercentage = data.taxPercentage;
    item.controls.task.value.total = data.total;

    item.controls.subtotal.setValue(data.subtotal);
    item.controls.tax.setValue(data.tax);
    item.controls.taxPercentage.setValue(data.taxPercentage);
    item.controls.total.setValue(data.total);

    // this.calculateTotals();
  }

  async createReceipt() {
    let data: any = _.cloneDeep(this.form.value);
    let body = {
      company: this._AuthService.companyId(),
      client: data.client._id,
      paymentDate: new Date(),
      dueDate: new Date(),
      billingDocument: this.document._id,
      total: data.total,
      termsAndConditions: data.termsAndConditions,
      paymentMethod: data.paymentMethod,
      paymentMethodType: data.paymentMethodType
    }
    const receipt = this._BillingDocumentService.createReceipt(body).toPromise();
    return receipt;
  }

  saveAsDraft() {
    this.f['serie'].setValue(this.invoiceStatuses.DRAFT);
    this.f['status'].setValue(this.invoiceStatuses.DRAFT);
    this.onSubmit();
  }

  onClientSelectionChange() {
    this.form.get('client')?.setErrors({ 'notToBilling': null });
  }

  issueInvoice() {
    if (this.f['serie'].value == this.invoiceStatuses.DRAFT)
      return this._AlertService.warn("Seleccione la serie a utilizar!");
    this.f['status'].setValue(this.invoiceStatuses.ISSUED);
    this.onSubmit(this.invoiceStatuses.ISSUED);
  }

  setPaidInvoice() {
    // this.f.status.setValue(this.invoiceStatuses.PAID);
    this.onSubmit(this.invoiceStatuses.PAID);
  }

  openCompanyModal(company: ICompany) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '600px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.companyDialogRef = this._dialog.open(CompaniesModalComponent, config);
    self.companyDialogRef.componentInstance.company = company;
    self.companyDialogRef.componentInstance.toBilling = true;
    self.companyDialogRef.componentInstance.readOnly = false;

    self.companyDialogRef.afterClosed().subscribe((result: any) => {
      self.companyDialogRef = null;
      this.getCompany(true);
    });
  }

  openNewClientModal() {
    this.openClientModal({});
  }

  openClientModal(client: IClient) {
    //console.log(client)
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '1100px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.clientDialogRef = this._dialog.open(ClientsModalComponent, config);
    self.clientDialogRef.componentInstance.client = client;
    self.clientDialogRef.componentInstance.toBilling = true;
    self.clientDialogRef.componentInstance.readOnly = false;

    self.clientDialogRef.afterClosed().subscribe((result: any) => {
      self.clientDialogRef = null;
      if (result) this.f['client'].setValue(result);
    });
  }

  onSubmit(newStatus?: string) {
    let data: any = _.cloneDeep(this.form.value);
    data.details = _.cloneDeep(this.document.details);

    /*for (let detail of data.details) {
      if (detail.detail && detail.detail.length > 50) {
        return;
      }
      if (detail.description && detail.description.length > 100) {
        return;
      }
    }*/

    // console.log(data)
    // validadores alert
    if (!data.client || !data.serie) {
      this.scrollDialogToTop();
      // Asignar error al control del formulario si falta el cliente
      const clientControl = this.form.get('client');
      const serieControl = this.form.get('serie');
      if (!data.client) {
        clientControl?.setErrors({ notFound: true });
        clientControl?.markAsTouched();
      }
      if (!data.serie) {
        serieControl?.setErrors({ required: true });
        serieControl?.markAsTouched();
      }

      return this._AlertService.warn("Para crear una factura, debe especificar el cliente / su serie");
    }
    if (data.subtotal == 0) return this._AlertService.warn("No se permiten Facturas con valor 0");
    if (data.details.filter((el: any) => el.detail == "").length) return this._AlertService.warn("No se permiten detalles vacíos");
    if (!data.details.length) return this._AlertService.warn("Ingrese algun detalle para continuar");
    if (!(data.subtotal > 0)) return this._AlertService.warn("La Factura debe tener Total mayor o igual a cero");
    if (!(data.total > 0)) return this._AlertService.warn("La Factura debe tener Total mayor o igual a cero");

    data.details.forEach((det: any) => det.serviceAgreement = det.serviceAgreement?._id ?? det.serviceAgreement)

    if (!this.allDataToBilling) {
      this._AlertService.warn("Debe completar sus datos fiscales (Nombre, Número de Identificación Fiscal, Dirección, Email y Número de Teléfono)");
      this.openCompanyModal(this.currentCompany);
      return
    }
    if (!data.client.firstname || !data.client.nit || !data.client.taxAddress) {
      this._AlertService.warn("Debe completar los datos fiscales del cliente (Nombre, Número de Identificación Fiscal y Dirección fiscal)");
      this.openClientModal(data.client);
      return
    }

    this.submitted = true;
    if (this.form.invalid) return;

    if (this.project) data.project = this.project;
    if ((this.tasks[0] as any)?.project) data.project = (this.tasks[0] as any)?.project;

    let isNewBillDoc = this.action === 'Crear' ? true : false

    const modalOptions: IConfirmationDialogOptions = {
      title: "Guardar Factura",
      message: (isNewBillDoc ? 'IMPORTANTE: Cuando se cree la factura, se guardará de forma segura.\nEste proceso no puede revertirse y los cambios que podrán realizarse en la factura serán limitados.' : 'Está seguro que desea Guardar esta Factura?'),
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe(async (confirmation: any) => {
        if (confirmation) {
          this.saving = true;
          data.company = this._AuthService.companyId();

          if (this.formValueChanged) {
            this.refreshPage = true;
          }

          // REFACTOR
          let date = data.date ?
            data.date.substring(0, 10) + 'T12:00:00.000Z' :
            new Date().toISOString().substring(0, 10) + 'T12:00:00.000Z';

          let dueDate = data.dueDate ?
            data.dueDate.substring(0, 10) + 'T12:00:00.000Z' :
            new Date().toISOString().substring(0, 10) + 'T12:00:00.000Z';

          let invoiceData: IBillingDocument = {
            company: this._AuthService.companyId(),
            client: data.client._id,
            date: date,
            dueDate: dueDate,

            subtotal: data.subtotal,
            tax: data.tax,
            taxPercentage: data.taxPercentage,
            total: data.total,

            details: [],

            project: data.project,
            notes: data.notes,
            termsAndConditions: data.termsAndConditions,
            serie: data.serie,
            paymentMethod: data.paymentMethod,
            paymentMethodType: data.paymentMethodType,

            status: data.status
          };

          for (const detail of data.details) {
            // console.log(detail.task);

            if (_.get(detail, 'task.toUpdate')) {
              const data = {
                _id: detail.task._id,
                company: detail.task.company._id,
                products: [],
                subtotal: detail.task.subtotal,
                tax: detail.task.tax,
                taxPercentage: detail.task.taxPercentage,
                total: detail.task.total,
              }
              data.products = detail.task.products.map((item: any) => {
                return { product: item.product._id, name: item.name, quantity: item.quantity, price: item.price, cost: item.cost }
              });
              await this._TaskHttpService.updateTask(data).toPromise();
            }

            try { detail.task = detail.task._id; } catch (e) { }

            if (!(detail.subtotal === 0 && detail.taxPercentage === 0 && (!detail.detail || detail.detail === ""))) {
              invoiceData.details?.push(detail);
            }
          }

          if (this.document._id) {
            invoiceData._id = this.document._id;
            const method = newStatus == this.invoiceStatuses.ISSUED ? 'issueInvoiceDocument' : 'updateBillingDocument';
            this._BillingDocumentService[method](invoiceData).subscribe({
              next: async (doc) => {
                this._broadcaster.broadcast('OnBillingDocChange', doc);
                this._broadcaster.broadcast('OnTaskChange', true);
                if (newStatus == this.invoiceStatuses.PAID) await this.createReceipt();
                this.submitted = false;
                this.saving = false;
                this.setEditable(false);
                this.getDocument();
                this.getReceipt();
                if (newStatus) this.dialog.close(doc);
              },
              error: () => this.saving = false
            });
          }

          else {
            this._BillingDocumentService.createInvoice(invoiceData).subscribe({
              next: (doc) => {
                this._broadcaster.broadcast('OnBillingDocChange', doc);
                this._broadcaster.broadcast('OnTaskChange', true);
                if (this.redirectToBill && !invoiceData.project) {
                  this._router.navigate(['/admin', this._AuthService.companyIndex(), 'billing-documents']).then(() => {
                    window.location.reload();
                  });
                } else {
                  this.document._id = doc._id;
                  this.submitted = false;
                  this.saving = false;
                  this.setEditable(false);
                  this.dialog.close(doc);
                  this.action = 'Modificar';
                  this.getDocument();
                }
              },
              error: () => this.saving = false
            });
          }
        }
      });
  }

  openDocument() {
    let config = new MatDialogConfig();
    config.width = '1200px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.pdfDialogRef = this._dialog.open(BillingDocumentsPDFModalComponent, config);
    self.pdfDialogRef.componentInstance.document = this.document;

    self.pdfDialogRef.afterClosed().subscribe((result: any) => {
      self.pdfDialogRef = null;
    });
  }

  cancelBtnHover = false;

  toggleCancelBtnHover(isHovering: boolean): void {
    this.cancelBtnHover = isHovering;
  }

  download() {
    const isDraft = this.document.status === this.invoiceStatuses.DRAFT;
    const name = isDraft
      ? `Factura de ${this._AuthService.company().name} - Vto. ${self.document.dueDate.toString().split('T')[0]} (BORRADOR)`
      : `Factura ${this.document.serieAndNumber} de ${this._AuthService.company().name} - Vto. ${self.document.dueDate.toString().split('T')[0]}`;
    this._BillingDocumentService.download(self.document._id, name);
  }

  downloadReceipt() {
    const name = `Recibo de Factura ${this.document.serieAndNumber} de ${this._AuthService.company().name}`;
    const id = this.document.receipt._id ? this.document.receipt._id : this.document.receipt;
    this._BillingDocumentService.downloadReceipt(id, name);
  }

  sendEmail() {
    if ((this.document.client as any).emails.length > 0) {

      const modalOptions: IConfirmationDialogOptions = {
        title: "Enviar por email",
        message: "¿Desea enviar la factura a la siguiente dirección? " + (this.document.client as any).emails[0].address,
        yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
      };

      this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
        .subscribe((confirmation: any) => {
          if (confirmation) {
            let data = {};
            this._BillingDocumentService.sendEmail(this.document._id, data).subscribe((result: any) => {
              result ? notify(`Email enviado correctamente`, "info", 1500) : notify(`Error al enviar email`, "error", 1500);
            });
          }
        });
    } else {
      this._AlertService.warn("El cliente no tiene un email cargado");
    }
  }

  removePaymentsInvoice() {
    let data: any = _.cloneDeep(this.form.value);

    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Pago",
      message: "Si elimina el pago, la factura dejará de estar en estado “Pagada”.",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._BillingDocumentService.deleteReceipt(this.document.receipt).subscribe(result => {
            this._BillingDocumentService.updateBillingDocument({
              _id: this.document._id, status: this.invoiceStatuses.ISSUED
            }).subscribe(result => {
              this.dialog.close();
            });
          });
        }
      });
  }

  cancelDocument() {
    let data: any = _.cloneDeep(this.form.value);
    data.details = _.cloneDeep(this.document.details);
    const includeTasks = data.details.filter((el: any) => el.task ? true : false).length > 0;
    const isPaid = this.document.status == this.invoiceStatuses.PAID;

    const modalOptions: IConfirmationDialogOptions = {
      title: "Cancelar Factura",
      message: "Está seguro que desea Cancelar esta Factura? " +
        (includeTasks ? 'Todos los trabajos incluidos en ella volverán a estado “Completado”. ' : '') +
        (isPaid ? 'Se eliminará su recibo de pago ' : ''),
      yesButtonLabel: 'Eliminar Factura', noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          if (isPaid)
            this._BillingDocumentService.deleteReceipt(this.document.receipt).subscribe(result => {
              this._BillingDocumentService.cancelBillingDocument(this.document).subscribe(result => {
                this._broadcaster.broadcast('OnBillingDocChange', result);
                this._broadcaster.broadcast('OnTaskChange', true);
                this.dialog.close();
              });
            });
          else
            this._BillingDocumentService.cancelBillingDocument(this.document).subscribe(result => {
              this._broadcaster.broadcast('OnBillingDocChange', result);
              this._broadcaster.broadcast('OnTaskChange', true);
              this.dialog.close();
            });
        }
      });
  }

  openUnderConstructionDialog() {
    const modalOptions: IInformationDialogOptions = {
      title: "¡Próximamente!",
      message: "Esta funcionalidad se encuentra en construcción.",
      closeButtonLabel: "Ok"
    };
    this._dialogService.openInformationModal(modalOptions, this._viewContainerRef)
      .subscribe(() => {
        console.log('ok')
      });
  }

  /*----------------- Detail ------------------*/
  onListChange(event: any) {
    // console.log(event);
    // this.f.details.setValue(event.items);
    this.f['subtotal'].setValue(event.totals.subtotal);
    this.f['tax'].setValue(event.totals.tax);
    this.f['total'].setValue(event.totals.total);
  }

  confirmExit() {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Salir",
      message: "¿Está seguro de que desea salir? Los cambios no se guardarán",
      yesButtonLabel: 'Sí, deseo salir',
      noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: boolean) => {
        if (confirmation) {
          self.dialogRef.close();
        }
      });
  }

  closeModal() {
    if (!this.readOnly && this.formValueChanged) {
      this.confirmExit()
    } else {
      if (this.refreshPage) {
        self.dialogRef.close(this.document);
      } else {
        self.dialogRef.close();
      }
    }
  }
}

function clientValidator(control: AbstractControl): { [key: string]: any } | null {
  console.log(control.value);

  // Si el valor es nulo o vacío, no se genera un error (otros validadores, como required, manejarán esto)
  if (!control.value) return null;

  // Validar si el cliente no tiene _id
  if (!_.get(control.value, '_id')) {
    return { notFound: true };
  }

  // Validar si faltan datos fiscales
  const missingBillingData = !_.get(control.value, 'firstname') || 
                             !_.get(control.value, 'nit') || 
                             !_.get(control.value, 'taxAddress');

  if (missingBillingData) {
    return { notToBilling: true };
  }

  return null;
}

function oneOrMoreDetails() {
  return (group: UntypedFormGroup) => {
    let detailsControl = group.controls['details'];
    if (!detailsControl.value.length) detailsControl.setErrors({ emptyDetails: true })
  }


}